/**
 * Swagger Interface
 * 数据交换格式: JSON
 *
 * OpenAPI spec version: v2.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import ajax, { AjaxPromise, ExtraFetchParams } from '@ajax';
import * as models from '../model/models';

/* tslint:disable:no-unused-variable member-ordering object-literal-shorthand */

/**
 * @description thumbUpArticleIdUsingDelete参数
 * @property `articleId` 文章id
 */
export interface ParamsthumbUpArticleIdUsingDelete {
  // pathParams
  /**
   * 文章id
   */
  articleId: number;
}
/**
 * @description thumbUpArticleIdUsingGet参数
 * @property `articleId` 文章id
 */
export interface ParamsthumbUpArticleIdUsingGet {
  // pathParams
  /**
   * 文章id
   */
  articleId: number;
}
/**
 * @description thumbUpArticleIdUsingPost参数
 * @property `articleId` 文章id
 */
export interface ParamsthumbUpArticleIdUsingPost {
  // pathParams
  /**
   * 文章id
   */
  articleId: number;
}
/**
 * @description thumbUpNewArticleBusinessIdUsingDelete参数
 * @property `articleBusinessId` 文章businessId
 */
export interface ParamsthumbUpNewArticleBusinessIdUsingDelete {
  // pathParams
  /**
   * 文章businessId
   */
  articleBusinessId: string;
}
/**
 * @description thumbUpNewArticleBusinessIdUsingGet参数
 * @property `articleBusinessId` 文章businessId
 */
export interface ParamsthumbUpNewArticleBusinessIdUsingGet {
  // pathParams
  /**
   * 文章businessId
   */
  articleBusinessId: string;
}
/**
 * @description thumbUpNewArticleBusinessIdUsingPost参数
 * @property `articleBusinessId` 文章businessId
 */
export interface ParamsthumbUpNewArticleBusinessIdUsingPost {
  // pathParams
  /**
   * 文章businessId
   */
  articleBusinessId: string;
}
export class ThumbUpApi {
  protected $basePath = '/community/be'.replace(/\/$/, '');

  public constructor(basePath?: string) {
    if (basePath !== undefined) {
      this.$basePath = basePath.replace(/\/$/, '');
    }
  }

  /**
   * 
   * @summary 取消点赞
   * @param params ParamsthumbUpArticleIdUsingDelete
   
   * @param opt ajax config
   * @returns models.CommonResultint
   */
  public thumbUpArticleIdUsingDelete = (
    params: ParamsthumbUpArticleIdUsingDelete,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultint> => {
    const path = '/api/thumb-up/{articleId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.articleId, 'articleId');
    return ajax.ajax(
      {
        ...opt,
        method: 'DELETE',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 获取文章点赞数
   * @param params ParamsthumbUpArticleIdUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultArticleThumbUpInfo
   */
  public thumbUpArticleIdUsingGet = (
    params: ParamsthumbUpArticleIdUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultArticleThumbUpInfo> => {
    const path = '/api/thumb-up/{articleId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.articleId, 'articleId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 点赞
   * @param params ParamsthumbUpArticleIdUsingPost
   
   * @param opt ajax config
   * @returns models.CommonResultint
   */
  public thumbUpArticleIdUsingPost = (
    params: ParamsthumbUpArticleIdUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultint> => {
    const path = '/api/thumb-up/{articleId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.articleId, 'articleId');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 取消点赞
   * @param params ParamsthumbUpNewArticleBusinessIdUsingDelete
   
   * @param opt ajax config
   * @returns models.CommonResultint
   */
  public thumbUpNewArticleBusinessIdUsingDelete = (
    params: ParamsthumbUpNewArticleBusinessIdUsingDelete,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultint> => {
    const path = '/api/thumb-up/new/{articleBusinessId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.articleBusinessId, 'articleBusinessId');
    return ajax.ajax(
      {
        ...opt,
        method: 'DELETE',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 获取文章点赞数
   * @param params ParamsthumbUpNewArticleBusinessIdUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultArticleThumbUpInfo
   */
  public thumbUpNewArticleBusinessIdUsingGet = (
    params: ParamsthumbUpNewArticleBusinessIdUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultArticleThumbUpInfo> => {
    const path = '/api/thumb-up/new/{articleBusinessId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.articleBusinessId, 'articleBusinessId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 点赞
   * @param params ParamsthumbUpNewArticleBusinessIdUsingPost
   
   * @param opt ajax config
   * @returns models.CommonResultint
   */
  public thumbUpNewArticleBusinessIdUsingPost = (
    params: ParamsthumbUpNewArticleBusinessIdUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultint> => {
    const path = '/api/thumb-up/new/{articleBusinessId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.articleBusinessId, 'articleBusinessId');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
}

export default new ThumbUpApi();
